




































import { Component, Vue ,Watch} from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryCityGoodsList, BatchDeleteCityGoods, BatchAddCityGoods, QuerySupplierList, QueryAllShopNameList ,QueryEachCityGoodsCount
  ,QueryCityClassifyTree,DeleteCityClassify} from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import { getNameById } from '@/store/classifyStore'
import {PriceFormat,GoodsStatusFormat} from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import {getUser} from '@/store/userStore'
import SelectGoodsDialog from '@/components/goods/SelectGoodsDialog.vue'
import pcaData from '@/assets/pca.json'
import EditCityClassify from './components/EditCityClassify.vue'

@Component({
  components: {
    VQuery,
    VTable,
    SelectGoodsDialog,
    EditCityClassify
  },
})
export default class CityGoods extends Vue {
  private pcaData  = pcaData
  private queryParam = {
    startRow: 1,
    limit: 10,

  }
  private goodsCounts = {
    saleingCount:0,
    saleOverCount:0,
    putDownCount:0,
    auditCount: 0,
    auditErrorCount: 0,
  }
  private tableTotal = 0
  private tableData = []
  private cityGoodsCountMap = {}
  private tableCurrntPage = 1
  private activeMenu = 'ALL'

  private supplierOption: Array<any> = []
  private shopIdOption: Array<any> = []
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}
  private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption,show:()=>{return this.userInfo.user.role != 2}}

  private  userInfo = getUser()
  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '排序方式', param: 'sortType' , type: 'select', selectData: constant.SortType},
    // this.supplierQueryParam,
    this.shopIdQueryParam,
    { title: '商品名称', param: 'goodsName' },
    { title: '商品编号', param: 'goodsCode' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '添加商品', type: 'primary', click: this.addGoods },
    { title: '批量删除', type: 'danger', click: this.batchRemoveIndex },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '分类', param: 'cityClassifyNmae' },
    // { title: '供应商编号', param: 'supplierCode' },
    { title: '店铺', param: 'goodsInfo.shopId' ,formatter: this.shopNameForam, overflow: true},
    { title: '商品编号', param: 'goodsCode' , overflow: true,width:200},
    { title: '商品名称', param: 'goodsInfo.goodsName' , overflow: true,width:200},
    { title: '商品图片', param: 'goodsInfo.goodsBanners' , width: 80 , slotName:'bannerImage' },
    { title: '一级分类', param: 'goodsInfo.goodsOneClassifyId' , formatter: getNameById},
    { title: '二级分类', param: 'goodsInfo.goodsTwoClassifyId' ,formatter: getNameById},
    { title: '三级分类', param: 'goodsInfo.goodsThreeClassifyId' ,formatter: getNameById},
    { title: '销售价', param: 'goodsInfo.showPrice' ,formatter: this.showPriceFormat},
    { title: '市场价', param: 'goodsInfo.marketPrice' ,formatter: PriceFormat},
    { title: 'PV', param: 'goodsInfo.minPv' ,formatter: this.showPvFormat},
    { title: '库存', param: 'goodsInfo.inventory' },
    { title: '状态', param: 'goodsInfo.goodsStatus' ,formatter: GoodsStatusFormat},
    { title: '排序', param: 'cityGoodsSort' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      width: 80,
      fixed: 'right',
      operation: [
        { title: '移除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }

  private filterText = "";
  @Watch('filterText',{deep: true})
  private filterTextWatch(){
    const d = this.$refs.treeRef as any
    d.filter(this.filterText);
  }
  private filterNode(value:any,data:any){
      if (!value) return true;
          return data.name.indexOf(value) !== -1;
  }

  private selectNode = {id:undefined,classifyName:undefined,imageUrl: undefined,idPath:undefined};
  private selectNodeName = ""
  private nodeClick(v:any){
    const fp = this.getNodeFullPath(v.id,this.cityClassifyTree.children)
    this.selectNodeName = fp.map((e:any)=>e.classifyName).join("/")

    this.selectNode =  v
    this.loadData()
  }
  // 核心：递归查找节点的全链路（包含自身）
  private getNodeFullPath(id:any, treeData:any, parentPath: any[] = []):any {
    for (const node of treeData) {
      // 拼接当前路径（父路径 + 当前节点）
      const currentPath = [...parentPath, node];
      // 找到目标节点，返回全链路
      if (node.id === id) {
        return currentPath;
      }
      // 若有子节点，递归查找
      if (node.children && node.children.length) {
        const result = this.getNodeFullPath(id, node.children, currentPath);
        if (result) return result; // 找到后返回
      }
    }
    return null; // 未找到（理论上不会触发）
  }


    public batchRemoveIndex() {
       if(this.tableSelectData.length<=0){
        this.$message.error("请选择商品")
        return
    }
    MessageBox.confirm('确定要将选择的商品移除首页吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchDeleteCityGoods({ ids: this.tableSelectData.map(item=>item.id) })
      if (ruslt) {
        Message.success('移除成功')
        this.loadData()
      }
    })
  }

  public batchAddIndexGoods(d: any){
    if(!d || d.length == 0){
      return
    }
    if(!this.selectNode.idPath){
      this.$message.error("请先选择左侧的城市")
      return
    }
    const ids = d.map((e: any)=>e.id)
    BatchAddCityGoods({
      cityClassifyId: this.selectNode.id,
      idPath: this.selectNode.idPath,
      goodsIds: ids
    }).then(res=>{
      if(res){
        this.$message.success("添加成功")
        this.loadData()
      }
    })
  }

  public async created() {
    this.loadData()
    // await this.loadSupplier()
    this.loadCityClassifyTree()
    this.loadShop()
  }

  private cityClassifyTree = {id:0,classifyName:"根目录",children:[]}
  private loadCityClassifyTree(){
    QueryCityClassifyTree({}).then(res=>{
      this.cityClassifyTree = res
      if(this.selectNode.id){
        // 获取最新的
        const fp = this.getNodeFullPath(this.selectNode.id,this.cityClassifyTree.children)
        this.selectNode = fp[fp.length - 1]
      }
    })
  }

  private editCityClassify(data:any){
    const d = this.$refs.EditCityClassify as EditCityClassify
    d.open(data)
  }

  private deleteCityClassify(data:any){
    this.$confirm(`是否删除:${data.classifyName}？`, '提示', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      DeleteCityClassify({id:data.id}).then(res=>{
        if(res){
          this.$message.success("删除成功")
          this.loadCityClassifyTree()
        }
      })
    })

  }

  private activeMenuSelect(e:string){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    this.search()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption

  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  private getGoodsBanner(value: string){
    console.log("getGoodsBanner")
    console.log(value)
    if(value){
      const vs = value.split(",")
      console.log("vs")
      console.log(vs)
      return vs[0]
    }
    return ""
  }

  public addGoods() {
    if(!this.selectNode.idPath){
      this.$message.error("请先选择左侧城市")
      return
    }
    (this.$refs.SelectGoodsDialog as SelectGoodsDialog).open()
    // this.$router.push("/createGoodsPage")
  }

  public async loadData() {
    if(!this.selectNode.idPath){
      this.tableTotal = 0
      this.tableData = []
      this.loadCountMap()
      return
    }
    // 排序
    const param: any = { ...this.queryParam }

    param.orderBy = "city_goods_sort desc, create_time desc"
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    param.idPath = this.selectNode.idPath

    const result = await QueryCityGoodsList(param)
    this.tableTotal = result.total
    this.tableData = result.list

    this.loadCountMap()
  }

  public async loadCountMap(){
    const result2 = await QueryEachCityGoodsCount({})
    const cm:any = {}
    result2.forEach((e:any) => {
      cm[e.cityClassifyId] = e.count
    });
    this.cityGoodsCountMap = cm
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    MessageBox.confirm('确定要将商品移除首页吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchDeleteCityGoods({ ids: [data.id] })
      if (ruslt) {
        Message.success('移除成功')
        this.loadData()
      }
    })
  }
  // 显示价格
  private showPriceFormat(v:any,row:any){
    let showPrice = ''
    if(row.minPrice == row.maxPrice){
      showPrice = PriceFormat(row.minPrice)
    } else {
      showPrice = PriceFormat(row.minPrice) + '~' + PriceFormat(row.maxPrice)
    }
    return showPrice
  }
  // 显示Pv
  private showPvFormat(v:any,row:any){
    let showPv = ''
    if(row.minPv == row.maxPv){
      showPv = PriceFormat(row.minPv)
    } else {
      showPv = PriceFormat(row.minPv) + '~' + PriceFormat(row.maxPv)
    }
    return showPv
  }
  // 显示店铺名称
  private shopNameForam(v:number){
    const t = this.shopIdOption.find(e=>e.value == v)
    if(t){
      return t.label
    }
    return v
  }
}
